import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { createKey } from '../../../utils/atsLayoutUtils';
import { PatternHandler } from '../../../views/ats-pages/PatternHandler';
import css from './ats-carousel.module.scss';
import { CarouselCard } from './carousel-card';
import { useCarousel } from './use-carousel';

interface AtsCarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  view: Layout.SectionView;
  data: Layout.SectionItem[];
  interval?: number;
  className?: string;
}

export default function AtsCarousel({ view, data, interval, className, ...rest }: AtsCarouselProps) {
  const { activeSlide, activeIndex, getContainerProps, getControlsProps, getPickerProps, getActiveSlideProps } =
    useCarousel({
      id: view.slug,
      slides: data,
      interval: interval || null,
    });

  return (
    <section className={css.container} {...getContainerProps(view.label)} {...rest}>
      <div className={css.controlsContainer}>
        <div className={css.controls} {...getControlsProps()}>
          {data.map((item, index) => (
            <CarouselCard
              key={index}
              item={item}
              pattern={'wide'}
              isActive={activeIndex === index}
              {...getPickerProps(index)}
            />
          ))}
        </div>
      </div>

      <AnimatePresence initial={false}>
        <motion.div
          key={createKey(activeSlide)}
          className={css.slide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <PatternHandler pattern={'banner-fullscreen'} item={activeSlide} {...getActiveSlideProps()} />
        </motion.div>
      </AnimatePresence>
    </section>
  );
}

function AtsCarouselSkeleton({ view, className }: Pick<AtsCarouselProps, 'view' | 'className'>) {
  return (
    <div className={css.container}>
      <PatternHandler.Skeleton pattern={view.style.pattern} />
    </div>
  );
}

AtsCarousel.Skeleton = AtsCarouselSkeleton;
